module.exports = __webpack_public_path__ + "static/img/yonghuzhongxin.ec258df2.png";